export const COLOR = {
  ORANGE: 'orange-500',
  BLUE: 'blue-700',
  YELLOW: 'yellow-600',
  RED: 'red-800',
  GREEN: 'green-400',
  PURPLE: 'purple-300',
  GRAY: 'gray-700',
  INDIGO: 'indigo-500',
  PINK: 'pink-200',
  TEAL: 'teal-600',
  LIME: 'lime-400',
  AMBER: 'amber-300',
  VIOLET: 'violet-700',
  FUCHSIA: 'fuchsia-600',
  ROSE: 'rose-400',
  SKY: 'sky-300',
  EMERALD: 'emerald-500',
  CYAN: 'cyan-800',
  FUCHSIA_400: 'fuchsia-400',
  LIME_200: 'lime-200',
};

export const COLORS = Object.values(COLOR);

export const MAX_GAME_GENERATION_RETRY = 10;

export const MAX_COLOR_COUNT = 24;

export const MAX_TUBES_PER_ROW = 6;
